import request from '@/axios'


// 获取某个学生信息
export function getPersonOnce(id) {
    return request({
        url: `/base/person/info/${id}`,
        method: 'get',
    })
}

// 获取人员
export function listBase(data={}) {
    return request({
        url: '/base/person/list',
        method: 'get',
        params: data
    })
}

// 导入人员
export function importBase(data=[]) {
    return request({
        url: '/base/person/import',
        method: 'post',
        data: data
    })
}

// 新增学生
export function addStudent(data={}) {
    return request({
        url: '/base/person/save',
        method: 'post',
        data
    })
}
// 修改学生信息
export function updateStudent(data={}) {
    return request({
        url: '/base/person/update',
        method: 'post',
        data
    })
}
// 重置密码
export function resetPassword(data=[]) {
    return request({
        url: '/base/person/resetpwd',
        method: 'post',
        data
    })
}
// 转移缴费代表
export function updateJiaofei(data={}) {
    return request({
        url: '/room/person/mgTransfer',
        method: 'post',
        data
    })
}
// 解绑宿舍
export function jiebangPeo(data=[]) {
    return request({
        url: '/room/person/unbind',
        method: 'post',
        data
    })
}
// 删除学生信息
export function delStudent(id) {
    return request({
        url: '/base/person/delete',
        method: 'post',
        data: [id]
    })
}

